<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';
import * as XLSX from "xlsx";

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Descargar eventos",
            items: [
                {
                    text: "Configuración",
                    href: "/"
                },
                {
                    text: "Eventos",
                    href: "/web/configuracion/eventos"
                },
                {
                    text: "Descargar eventos",
                    active: true
                }
            ],
            isLoading: false,
            exportando: false,
            eventos: [],
            filtros: {
                busqueda: '',
                estado: null,
                sede: null,
                coordinador: null,
                tipo: null,
                subtipo: null,
                comuna: null,
                region: null,
                fechaDesde: '',
                fechaHasta: '',
            },
            columnasPreferidas: [
                'id',
                'codigo',
                'nombre_difusion',
                'estado_actividad',
                'fecha_inicio',
                'fecha_termino',
                'tipo_nombre',
                'subtipo_nombre',
                'rbd_colegio',
                'colegio',
                'sede_asociada',
                'comuna',
                'region',
                'propietario_colegio',
                'coordinador_evento',
                'num_asistentes',
                'telefono_notificaciones',
                'correo_notificaciones',
                'curso_multi',
                'campus',
            ],
            columnasExcluidas: new Set([
                'tipo',
                'tipo_codigo',
                'subtipo',
                'subtipo_codigo',
                'user_id',
                'cantidad_inscripciones',
                'created_at',
                'updated_at',
                'className',
                'end',
                'fecha_creacion',
                'landing_asistencia',
                'propietario',
                'rec1dia',
                'start',
                'tipo_landing',
                'title',
                'ultima_actualizacion',
                'data',
            ]),
        };
    },
    computed: {
        estadosOptions() {
            return this.buildUniqueOptions('estado_actividad');
        },
        sedesOptions() {
            return this.buildUniqueOptions('sede_asociada');
        },
        coordinadoresOptions() {
            return this.buildUniqueOptions('coordinador_evento');
        },
        tiposOptions() {
            return this.buildUniqueOptions('tipo_nombre');
        },
        subtiposOptions() {
            return this.buildUniqueOptions('subtipo_nombre');
        },
        comunasOptions() {
            return this.buildUniqueOptions('comuna');
        },
        regionesOptions() {
            return this.buildUniqueOptions('region');
        },
        eventosFiltrados() {
            const busqueda = this.normalizeText(this.filtros.busqueda);

            return this.eventos.filter((evento) => {
                if (busqueda) {
                    const contenido = this.normalizeText([
                        evento.codigo,
                        evento.nombre_difusion,
                        evento.colegio,
                        evento.rbd_colegio,
                        evento.coordinador_evento,
                        evento.estado_actividad,
                        evento.sede_asociada,
                        evento.tipo_nombre,
                        evento.subtipo_nombre,
                        evento.comuna,
                        evento.region,
                        evento.propietario_colegio,
                    ].join(' '));

                    if (!contenido.includes(busqueda)) {
                        return false;
                    }
                }

                if (this.filtros.estado && this.normalizeText(evento.estado_actividad) !== this.filtros.estado.value) {
                    return false;
                }

                if (this.filtros.sede && this.normalizeText(evento.sede_asociada) !== this.filtros.sede.value) {
                    return false;
                }

                if (this.filtros.coordinador && this.normalizeText(evento.coordinador_evento) !== this.filtros.coordinador.value) {
                    return false;
                }

                if (this.filtros.tipo && this.normalizeText(evento.tipo_nombre) !== this.filtros.tipo.value) {
                    return false;
                }

                if (this.filtros.subtipo && this.normalizeText(evento.subtipo_nombre) !== this.filtros.subtipo.value) {
                    return false;
                }

                if (this.filtros.comuna && this.normalizeText(evento.comuna) !== this.filtros.comuna.value) {
                    return false;
                }

                if (this.filtros.region && this.normalizeText(evento.region) !== this.filtros.region.value) {
                    return false;
                }

                if (this.filtros.fechaDesde) {
                    const inicioEvento = this.fechaComparable(evento.fecha_inicio);
                    if (!inicioEvento || inicioEvento < this.filtros.fechaDesde) {
                        return false;
                    }
                }

                if (this.filtros.fechaHasta) {
                    const inicioEvento = this.fechaComparable(evento.fecha_inicio);
                    if (!inicioEvento || inicioEvento > this.filtros.fechaHasta) {
                        return false;
                    }
                }

                return true;
            });
        },
        cantidadResultados() {
            return this.eventosFiltrados.length;
        },
        previewRows() {
            return this.eventosFiltrados.slice(0, 150);
        },
    },
    mounted() {
        this.cargarDatos();
    },
    methods: {
        msg(tipo, titulo) {
            Swal.fire({
                icon: tipo,
                title: titulo,
                showConfirmButton: false,
                timer: 3500,
            });
        },
        normalizeText(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim();
        },
        fechaComparable(fecha) {
            if (!fecha) {
                return '';
            }

            const valor = String(fecha).slice(0, 10);
            return /^\d{4}-\d{2}-\d{2}$/.test(valor) ? valor : '';
        },
        valorCatalogo(rawValue, nombreDirecto, porCodigo, porId) {
            const nombreNormalizado = String(nombreDirecto || '').trim();
            if (nombreNormalizado) {
                return nombreNormalizado;
            }

            const rawNormalizado = String(rawValue || '').trim();
            if (!rawNormalizado) {
                return '';
            }

            if (porCodigo[rawNormalizado]) {
                return porCodigo[rawNormalizado];
            }

            if (porId[rawNormalizado]) {
                return porId[rawNormalizado];
            }

            return rawNormalizado;
        },
        getCanonicalLabel(field, rawValue, normalizedValue) {
            if (!normalizedValue) {
                return '';
            }

            const canonicalByField = {
                sede_asociada: {
                    concepcion: 'Concepción',
                    santiago: 'Santiago',
                    'vina del mar': 'Viña del Mar',
                },
                comuna: {
                    concepcion: 'Concepción',
                    santiago: 'Santiago',
                    'vina del mar': 'Viña del Mar',
                },
                region: {
                    'metropolitana de santiago': 'Metropolitana de Santiago',
                    biobio: 'Biobío',
                    valparaiso: 'Valparaíso',
                    nuble: 'Ñuble',
                    araucania: 'Araucanía',
                    'ohiggins': "O'Higgins",
                    'los rios': 'Los Ríos',
                    'los lagos': 'Los Lagos',
                },
            };

            const canonical = canonicalByField[field] && canonicalByField[field][normalizedValue];
            return canonical || rawValue;
        },
        buildUniqueOptions(field) {
            const unique = new Map();

            this.eventos.forEach((evento) => {
                const rawValue = (evento[field] || '').toString().trim();
                const normalizedValue = this.normalizeText(rawValue);

                if (!normalizedValue) {
                    return;
                }

                if (!unique.has(normalizedValue)) {
                    unique.set(normalizedValue, this.getCanonicalLabel(field, rawValue, normalizedValue));
                }
            });

            return Array.from(unique.entries())
                .map(([value, label]) => ({ value, label }))
                .sort((left, right) => left.label.localeCompare(right.label, 'es'));
        },
        async cargarDatos() {
            this.isLoading = true;
            try {
                const [eventosResponse, tiposResponse, colegiosResponse] = await Promise.all([
                    axios.get('/api/get_eventos'),
                    axios.get('/api/get_tipos'),
                    axios.get('/api/get_colegios'),
                ]);

                const eventos = Array.isArray(eventosResponse.data.eventos)
                    ? eventosResponse.data.eventos
                    : [];
                const tipos = Array.isArray(tiposResponse.data.tipos)
                    ? tiposResponse.data.tipos
                    : [];
                const subtipos = Array.isArray(tiposResponse.data.subtipos)
                    ? tiposResponse.data.subtipos
                    : [];
                const colegios = Array.isArray(colegiosResponse.data.colegios)
                    ? colegiosResponse.data.colegios
                    : [];

                const tiposPorCodigo = tipos.reduce((acc, item) => {
                    const codigo = String(item.codigo || '').trim();
                    if (codigo) {
                        acc[codigo] = item.nombre;
                    }
                    return acc;
                }, {});

                const tiposPorId = tipos.reduce((acc, item) => {
                    const id = String(item.id || '').trim();
                    if (id) {
                        acc[id] = item.nombre;
                    }
                    return acc;
                }, {});

                const subtiposPorCodigo = subtipos.reduce((acc, item) => {
                    const codigo = String(item.codigo || '').trim();
                    if (codigo) {
                        acc[codigo] = item.nombre;
                    }
                    return acc;
                }, {});

                const subtiposPorId = subtipos.reduce((acc, item) => {
                    const id = String(item.id || '').trim();
                    if (id) {
                        acc[id] = item.nombre;
                    }
                    return acc;
                }, {});

                const colegiosPorRbd = colegios.reduce((acc, colegio) => {
                    const rbd = String(colegio.rbd || '').trim();
                    if (rbd) {
                        acc[rbd] = colegio;
                    }
                    return acc;
                }, {});

                this.eventos = eventos.map((evento) => {
                    const rbd = String(evento.rbd_colegio || '').trim();
                    const colegioRelacionado = colegiosPorRbd[rbd] || {};

                    const tipoRaw = evento.tipo_codigo || evento.tipo;
                    const subtipoRaw = evento.subtipo_codigo || evento.subtipo;

                    const tipoNombre = this.valorCatalogo(
                        tipoRaw,
                        evento.tipo_nombre,
                        tiposPorCodigo,
                        tiposPorId
                    );

                    const subtipoNombre = this.valorCatalogo(
                        subtipoRaw,
                        evento.subtipo_nombre,
                        subtiposPorCodigo,
                        subtiposPorId
                    );

                    return {
                        ...evento,
                        colegio: (evento.colegio || colegioRelacionado.nombre || ''),
                        comuna: (evento.comuna || colegioRelacionado.comuna || ''),
                        region: (evento.region || colegioRelacionado.region || ''),
                        propietario_colegio: (evento.propietario_colegio || colegioRelacionado.propietario || ''),
                        tipo_nombre: tipoNombre,
                        subtipo_nombre: subtipoNombre,
                    };
                });
            } catch (error) {
                this.msg('error', 'No se pudo cargar el listado de eventos');
            } finally {
                this.isLoading = false;
            }
        },
        limpiarFiltros() {
            this.filtros = {
                busqueda: '',
                estado: null,
                sede: null,
                coordinador: null,
                tipo: null,
                subtipo: null,
                comuna: null,
                region: null,
                fechaDesde: '',
                fechaHasta: '',
            };
        },
        valorExcel(value) {
            if (value === null || value === undefined) {
                return '';
            }

            if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
                try {
                    return JSON.stringify(value, null, 0);
                } catch (error) {
                    return String(value);
                }
            }

            return value;
        },
        buildExcelRows(source) {
            const rows = Array.isArray(source) ? source : [];
            const dynamicColumns = new Set();

            rows.forEach((row) => {
                Object.keys(row || {}).forEach((key) => {
                    if (!this.columnasExcluidas.has(key)) {
                        dynamicColumns.add(key);
                    }
                });
            });

            const orderedColumns = [
                ...this.columnasPreferidas.filter((column) => dynamicColumns.has(column)),
                ...Array.from(dynamicColumns).filter((column) => !this.columnasPreferidas.includes(column)).sort(),
            ];

            return rows.map((row) => {
                const exportRow = {};
                orderedColumns.forEach((column) => {
                    exportRow[column] = this.valorExcel(row[column]);
                });
                return exportRow;
            });
        },
        descargarExcel(source, nombreBase) {
            const rows = this.buildExcelRows(source);

            if (!rows.length) {
                this.msg('warning', 'No hay eventos para descargar con los filtros actuales');
                return;
            }

            this.exportando = true;
            try {
                const worksheet = XLSX.utils.json_to_sheet(rows);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Eventos');
                XLSX.writeFile(workbook, `${nombreBase}_${new Date().toISOString().slice(0, 10)}.xlsx`);
                this.msg('success', 'Excel generado correctamente');
            } catch (error) {
                this.msg('error', 'No se pudo generar el Excel');
            } finally {
                this.exportando = false;
            }
        },
        descargarFiltrados() {
            this.descargarExcel(this.eventosFiltrados, 'eventos_filtrados');
        },
        descargarTodos() {
            this.descargarExcel(this.eventos, 'eventos_completo');
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <div>
                                <h4 class="card-title mb-1">Filtros de eventos</h4>
                                <p class="text-muted mb-0">Aplica filtros antes de descargar el listado en Excel.</p>
                            </div>
                            <div class="d-flex flex-wrap mt-3 mt-md-0">
                                <b-button variant="light" class="mr-2 mb-2" @click="limpiarFiltros">
                                    Limpiar filtros
                                </b-button>
                                <b-button variant="primary" class="mr-2 mb-2" :disabled="exportando || !cantidadResultados" @click="descargarFiltrados">
                                    Descargar filtrados
                                </b-button>
                                <b-button variant="success" class="mb-2" :disabled="exportando || !eventos.length" @click="descargarTodos">
                                    Descargar todo
                                </b-button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>Buscar evento</label>
                                <b-form-input v-model.trim="filtros.busqueda" placeholder="Código, actividad, colegio, coordinador..."></b-form-input>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Fecha desde</label>
                                <b-form-input v-model="filtros.fechaDesde" type="date"></b-form-input>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Fecha hasta</label>
                                <b-form-input v-model="filtros.fechaHasta" type="date"></b-form-input>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Estado</label>
                                <multiselect
                                    v-model="filtros.estado"
                                    :options="estadosOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todos los estados"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Sede asociada</label>
                                <multiselect
                                    v-model="filtros.sede"
                                    :options="sedesOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todas las sedes"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Coordinador</label>
                                <multiselect
                                    v-model="filtros.coordinador"
                                    :options="coordinadoresOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todos los coordinadores"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Tipo</label>
                                <multiselect
                                    v-model="filtros.tipo"
                                    :options="tiposOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todos los tipos"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Subtipo</label>
                                <multiselect
                                    v-model="filtros.subtipo"
                                    :options="subtiposOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todos los subtipos"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Comuna</label>
                                <multiselect
                                    v-model="filtros.comuna"
                                    :options="comunasOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todas las comunas"
                                ></multiselect>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label>Región</label>
                                <multiselect
                                    v-model="filtros.region"
                                    :options="regionesOptions"
                                    label="label"
                                    track-by="value"
                                    :show-labels="false"
                                    placeholder="Todas las regiones"
                                ></multiselect>
                            </div>
                        </div>

                        <div class="alert alert-info d-flex justify-content-between align-items-center mb-0">
                            <span><strong>{{ cantidadResultados }}</strong> eventos coinciden con los filtros actuales.</span>
                            <span v-if="cantidadResultados > previewRows.length">Mostrando vista previa de {{ previewRows.length }} registros.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Vista previa del listado</h4>
                        <div v-if="isLoading" class="text-center text-muted py-5">
                            Cargando eventos...
                        </div>
                        <div v-else-if="!previewRows.length" class="text-center text-muted py-5">
                            No hay eventos que coincidan con los filtros seleccionados.
                        </div>
                        <div v-else class="table-responsive">
                            <table class="table table-bordered table-hover align-middle mb-0">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Actividad</th>
                                        <th>Fecha inicio</th>
                                        <th>Fecha término</th>
                                        <th>Estado</th>
                                        <th>Colegio</th>
                                        <th>RBD</th>
                                        <th>Sede</th>
                                        <th>Comuna</th>
                                        <th>Región</th>
                                        <th>Coordinador</th>
                                        <th>Tipo</th>
                                        <th>Subtipo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="evento in previewRows" :key="evento.id">
                                        <td>{{ evento.codigo }}</td>
                                        <td>{{ evento.nombre_difusion }}</td>
                                        <td>{{ evento.fecha_inicio }}</td>
                                        <td>{{ evento.fecha_termino }}</td>
                                        <td>{{ evento.estado_actividad || 'Sin estado' }}</td>
                                        <td>{{ evento.colegio }}</td>
                                        <td>{{ evento.rbd_colegio }}</td>
                                        <td>{{ evento.sede_asociada }}</td>
                                        <td>{{ evento.comuna }}</td>
                                        <td>{{ evento.region }}</td>
                                        <td>{{ evento.coordinador_evento }}</td>
                                        <td>{{ evento.tipo_nombre }}</td>
                                        <td>{{ evento.subtipo_nombre }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
